import { render, staticRenderFns } from "./SharedEcosystems.vue?vue&type=template&id=57ea9f9f&"
import script from "./SharedEcosystems.vue?vue&type=script&lang=js&"
export * from "./SharedEcosystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports